import Image from "next/image";
import { FC, useState } from "react";
import styles from "../../styles/common/ActivityIcon.module.scss";

const ActivityIcon: FC<{
    borderColor: string;
    src: string;
    alt: string;
    className?: string;
    isSmall?: boolean;
}> = ({ borderColor, src, alt, className = "", isSmall = false }) => {
    const [imageError, setImageError] = useState(false);
    return (
        <span
            className={
                isSmall
                    ? styles.spanIconContainerSmall
                    : styles.spanIconContainerNormal
            }
            style={{
                position: "relative",
                border: `2px solid ${imageError ? "red" : borderColor}`,
            }}
        >
            <Image
                src={imageError ? "/images/binoculars.png" : src}
                width={100}
                height={100}
                style={{
                    objectFit: "contain",
                    position: "unset",
                    height: "120%",
                    width: "110%",
                }}
                className={className}
                alt={alt}
                onError={() => {
                    setImageError(true);
                }}
            />
        </span>
    );
};

export default ActivityIcon;
